/* OPPCOLOR JP replica - interactions (no framework) */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- 公告条轮播 ---------------- */
  var ann = document.querySelector('[data-announcement-slider]');
  if (ann) {
    var slides = ann.querySelectorAll('.announcement-slide');
    if (slides.length > 1) {
      var idx = 0;
      var delay = parseInt(ann.getAttribute('data-delay') || '4000', 10);
      setInterval(function () {
        if (document.hidden) return;
        slides[idx].classList.remove('is-active');
        idx = (idx + 1) % slides.length;
        slides[idx].classList.add('is-active');
      }, reduceMotion ? delay * 4 : delay);
    }
  }

  /* ---------------- 顶部导航：滚动阴影 ---------------- */
  var nav = document.querySelector('.nav');
  if (nav) {
    var onScroll = function () {
      document.body.classList.toggle('is-scrolled', window.scrollY > 12);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------------- 移动端汉堡菜单 ---------------- */
  var toggle = document.querySelector('[data-menu-toggle]');
  var center = document.querySelector('[data-nav-center]');
  if (toggle && center) {
    toggle.addEventListener('click', function () {
      var open = center.classList.toggle('open');
      document.body.classList.toggle('mobile-menu-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'メニューを閉じる' : 'メニューを開く');
    });
    center.addEventListener('click', function (e) {
      if (e.target.closest('.nav-link')) {
        center.classList.remove('open');
        document.body.classList.remove('mobile-menu-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ---------------- Best Sellers 滑块 ---------------- */
  var wrap = document.querySelector('[data-purchase-entry-slider]');
  if (wrap) {
    var track = wrap.querySelector('.entry-products-track');
    var slides = track ? track.children : [];
    var prevBtn = document.querySelector('[data-purchase-entry-prev]');
    var nextBtn = document.querySelector('[data-purchase-entry-next]');
    var bullets = document.querySelectorAll('[data-purchase-entry-pagination] .swiper-pagination-bullet');
    var host = wrap.parentElement;

    var perView = function () {
      var desktop = host.getAttribute('data-desktop-slides');
      var mobile = host.getAttribute('data-mobile-slides');
      return window.innerWidth > 1080 ? parseFloat(desktop) : parseFloat(mobile);
    };
    var group = function () {
      var desktop = host.getAttribute('data-desktop-group');
      var mobile = host.getAttribute('data-mobile-group');
      return window.innerWidth > 1080 ? parseInt(desktop, 10) : parseInt(mobile, 10);
    };

    var page = 0;
    var pages = 1;

    var layout = function () {
      if (!track || !slides.length) return;
      var pv = perView();
      var itemW = slides[0].getBoundingClientRect().width;
      var gap = 14;
      var visible = Math.max(1, Math.floor(pv));
      var maxPage = Math.max(0, slides.length - visible);
      pages = Math.max(1, Math.ceil(maxPage / group()) + 1);
      if (page > pages - 1) page = pages - 1;
      var step = itemW * group() + gap * group();
      var maxShift = Math.max(0, track.scrollWidth - wrap.clientWidth);
      var shift = Math.min(page * step, maxShift);
      track.style.transform = 'translate3d(' + (-shift) + 'px,0,0)';

      if (prevBtn) prevBtn.disabled = page <= 0;
      if (nextBtn) nextBtn.disabled = page >= pages - 1;
      bullets.forEach(function (b, i) {
        b.classList.toggle('swiper-pagination-bullet-active', i === page);
      });
    };

    if (prevBtn) prevBtn.addEventListener('click', function () { page = Math.max(0, page - 1); layout(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { page = Math.min(pages - 1, page + 1); layout(); });
    bullets.forEach(function (b, i) {
      b.addEventListener('click', function () { page = i; layout(); });
    });

    /* 拖拽 */
    var down = false, startX = 0, startShift = 0, moved = false;
    track && track.addEventListener('pointerdown', function (e) {
      down = true; moved = false; startX = e.clientX;
      startShift = track.getBoundingClientRect().left;
    });
    track && track.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      /* 只有真正拖动超过 6px 才进入拖拽态，避免劫持普通点击 */
      if (!moved && Math.abs(dx) > 6) {
        moved = true;
        track.classList.add('is-dragging');
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
      }
      if (!moved) return;
      var maxShift = Math.max(0, track.scrollWidth - wrap.clientWidth);
      var cur = -parseFloat((track.style.transform.match(/-?[\d.]+/) || [0])[0]);
      var next = cur + dx;
      if (next < 0) next = next * 0.35;
      if (next > maxShift) next = maxShift + (next - maxShift) * 0.35;
      track.style.transform = 'translate3d(' + (-next) + 'px,0,0)';
    });
    /* 拖动结束后拦截紧随而来的 click，防止误触链接 */
    track && track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
    var endDrag = function () {
      if (!down) return;
      down = false;
      track.classList.remove('is-dragging');
      var cur = -parseFloat((track.style.transform.match(/-?[\d.]+/) || [0])[0]);
      var maxShift = Math.max(0, track.scrollWidth - wrap.clientWidth);
      var pv = perView();
      var itemW = slides[0].getBoundingClientRect().width;
      var step = itemW + 14;
      var approx = Math.round(cur / step);
      page = Math.max(0, Math.min(pages - 1, approx));
      layout();
    };
    track && track.addEventListener('pointerup', endDrag);
    track && track.addEventListener('pointercancel', endDrag);

    window.addEventListener('resize', layout);
    window.addEventListener('load', layout);
    layout();
  }

  /* ---------------- 商品图 hover 切换 ---------------- */
  document.querySelectorAll('.product-card img[data-hover]').forEach(function (img) {
    var main = img.getAttribute('src');
    var alt = img.getAttribute('data-hover');
    var holder = img.parentElement;
    var ghost = document.createElement('img');
    ghost.className = 'product-hover-image';
    ghost.src = alt;
    ghost.alt = '';
    ghost.setAttribute('aria-hidden', 'true');
    holder.appendChild(ghost);
    holder.addEventListener('mouseenter', function () { img.style.opacity = '0'; });
    holder.addEventListener('mouseleave', function () { img.style.opacity = ''; });
  });

  /* ---------------- 返回顶部 ---------------- */
  var top = document.querySelector('[data-back-to-top]');
  if (top) {
    var onScrollTop = function () {
      top.classList.toggle('is-visible', window.scrollY > 700);
    };
    window.addEventListener('scroll', onScrollTop, { passive: true });
    top.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    });
    onScrollTop();
  }

  /* ---------------- 区块入场动画 ---------------- */
  var revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-inview'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-inview'); });
  }

  /* ---------------- 视频弹窗 ---------------- */
  var modal = document.createElement('div');
  modal.className = 'youtube-video-modal';
  modal.setAttribute('aria-hidden', 'true');
  modal.innerHTML =
    '<button class="youtube-video-modal-backdrop" type="button" data-close aria-label="閉じる"></button>' +
    '<div class="youtube-video-dialog" role="dialog" aria-modal="true" aria-label="動画プレーヤー">' +
    '<div class="youtube-video-nav">' +
    '<button class="icon-button youtube-video-nav-button" type="button" data-prev aria-label="前の動画">' +
    '<svg width="15" height="15" viewBox="0 0 24 24" aria-hidden="true"><path d="m6 9 6 6 6-6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>' +
    '<button class="icon-button youtube-video-nav-button" type="button" data-next aria-label="次の動画">' +
    '<svg width="15" height="15" viewBox="0 0 24 24" aria-hidden="true"><path d="m6 9 6 6 6-6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>' +
    '</div>' +
    '<button class="icon-button youtube-video-close" type="button" data-close aria-label="閉じる">' +
    '<svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"></path></svg></button>' +
    '<iframe data-iframe title="YouTube 動画プレイヤー" src="about:blank" loading="lazy" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>' +
    '</div>';
  document.body.appendChild(modal);

  var frame = modal.querySelector('[data-iframe]');
  var cards = Array.prototype.slice.call(document.querySelectorAll('[data-youtube-video-card]'));
  var current = 0;

  var showVideo = function (i) {
    current = (i + cards.length) % cards.length;
    var btn = cards[current].querySelector('[data-youtube-video-open]');
    var id = btn ? btn.getAttribute('data-video-id') : '';
    frame.src = id ? 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0' : 'about:blank';
    modal.classList.add('open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('popup-lock');
  };
  var closeVideo = function () {
    modal.classList.remove('open');
    modal.setAttribute('aria-hidden', 'true');
    frame.src = 'about:blank';
    document.documentElement.classList.remove('popup-lock');
  };

  cards.forEach(function (card, i) {
    var btn = card.querySelector('[data-youtube-video-open]');
    if (btn) btn.addEventListener('click', function () { showVideo(i); });
  });
  modal.querySelectorAll('[data-close]').forEach(function (b) { b.addEventListener('click', closeVideo); });
  modal.querySelector('[data-prev]').addEventListener('click', function () { showVideo(current - 1); });
  modal.querySelector('[data-next]').addEventListener('click', function () { showVideo(current + 1); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('open')) closeVideo();
  });


  /* ---------------- 更多视频 ---------------- */
  var more = document.querySelector('[data-youtube-video-load-more]');
  if (more) {
    var STEP = 8;
    more.addEventListener('click', function () {
      var hidden = Array.prototype.slice.call(
        document.querySelectorAll('.youtube-video-card.is-hidden')
      );
      hidden.slice(0, STEP).forEach(function (el) { el.classList.remove('is-hidden'); });
      if (hidden.length <= STEP) {
        more.textContent = 'すべての動画を表示しました';
        more.disabled = true;
        more.style.opacity = '.6';
        more.style.cursor = 'default';
      }
    });
  }
})();

/* ---------------- サイズ表モーダル ---------------- */
(function () {
  var opens = document.querySelectorAll('[data-sizechart-open]');
  var modal = document.querySelector('[data-sizechart-modal]');
  if (!modal || !opens.length) return;

  function setOpen(show) {
    if (show) {
      modal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
    } else {
      modal.setAttribute('hidden', '');
      document.body.style.overflow = '';
    }
  }

  opens.forEach(function (btn) {
    btn.addEventListener('click', function () { setOpen(true); });
  });
  modal.querySelectorAll('[data-sizechart-close]').forEach(function (el) {
    el.addEventListener('click', function () { setOpen(false); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hasAttribute('hidden')) setOpen(false);
  });
})();
